import { render, staticRenderFns } from "./TransferGroup.vue?vue&type=template&id=33e1183e&scoped=true"
import script from "./TransferGroup.vue?vue&type=script&lang=js"
export * from "./TransferGroup.vue?vue&type=script&lang=js"
import style0 from "./TransferGroup.vue?vue&type=style&index=0&id=33e1183e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e1183e",
  null
  
)

export default component.exports